export default __webpack_public_path__ + "static/media/logo-xd.6e37886f.svg";